const RELOAD_STORAGE_KEY = 'engage:preload-error-reload-at';
const RELOAD_COOLDOWN_MS = 60_000;

const canReload = (now: number) => {
  try {
    const lastReload = Number(
      window.sessionStorage.getItem(RELOAD_STORAGE_KEY)
    );
    if (lastReload && now - lastReload < RELOAD_COOLDOWN_MS) {
      return false;
    }
    window.sessionStorage.setItem(RELOAD_STORAGE_KEY, String(now));
    return true;
  } catch {
    // Storage unavailable: skip the reload rather than risk a reload loop.
    return false;
  }
};

// Re-download the current HTML bypassing the HTTP cache so the reload picks up
// the fresh index.html (and its new chunk names).
const refreshDocumentCache = async () => {
  try {
    await fetch(window.location.href, { cache: 'reload' });
  } catch {
    // Offline or blocked: reload anyway.
  }
};

/**
 * After a deployment the browser may still hold an old index.html that points
 * to hashed chunks that no longer exist. Vite emits `vite:preloadError` when a
 * lazy chunk fails to load; we refresh the cached index.html and reload. The
 * cooldown guard prevents an infinite reload loop if the failure is not
 * caused by a stale build (the error then reaches the ErrorBoundary as usual).
 */
export const reloadOnPreloadError = () => {
  window.addEventListener('vite:preloadError', (event) => {
    if (canReload(Date.now())) {
      event.preventDefault();
      refreshDocumentCache().finally(() => window.location.reload());
    }
  });
};
